<template>
    <v-layout column>
        <v-layout>
            <v-flex class="mr-2">
                <v-toolbar class="text-h5" flat color="transparent">
                    <v-icon class="mr-3">{{ stepIcon }}</v-icon>
                    {{ stepTitle }}
                </v-toolbar>
                <v-layout column class="pa-1 mt-3">
                    <slot />
                </v-layout>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
export default {
  props: {
    stepTitle: {
      type: String
    },
    stepIcon: {
      type: String
    }
  }
};
</script>

<style scoped>

</style>
